import { createLocalAiAssistantReply } from './localAiAssistant';
import { getInternalAssistantEnvironment } from './internalAssistantRuntime';
import { isManualAiConfigured, requestManualAssistant } from '../supabase/internalManualAssistantService';

export async function createInternalAssistantReply(context) {
  if (!getInternalAssistantEnvironment() || !context.access?.ready) {
    return { answer: 'Inicia sesion y selecciona una sucursal autorizada para usar la ayuda.', actions: [] };
  }
  if (isManualAiConfigured() && context.access.branchId) {
    try { return await requestManualAssistant(context); }
    catch (error) {
      if (context.signal?.aborted) throw error;
      if ([401, 403, 400].includes(error.status)) return { answer: error.message, actions: [] };
      const local = await createLocalAiAssistantReply(context);
      return { ...local, sourceKind: 'local-fallback',
        answer: `No pude conectar con la IA. Esta respuesta es de la guia local y puede no entender el contexto anterior.\n\n${local.answer}` };
    }
  }
  return { ...await createLocalAiAssistantReply(context), sourceKind: 'local-fallback' };
}
